import React, { useEffect, Fragment, useState } from 'react'
import { compose } from 'recompose'
import { Grid, Button, Paper, Typography, Link, Box, CircularProgress, useMediaQuery, useTheme } from '@material-ui/core'
import LoginPagesWrapper from '../../../components/LoginPagesWrapper'
import { withRouter } from 'react-router'
import { getTeamBackgroundByEmail, getTeamLogoByEmail, getRegistrationStatus, sendVerificationCode, confirmCode, getTeamBackgroundByEncryptedLink, getTeamLogoByEncryptedLink, selfRegisterUser, resetRegistrationStatus, getCreatorInfoByEmail, getCreatorInfoByEncryptedLink, checkIfSelfRegistrationLinkHasExpired } from '../../../redux/actions'
import { connect } from 'react-redux'
import FormTextField from '../../../components/FormTextField'
import { reduxForm, change, formValueSelector } from 'redux-form'
import { required, email } from '../../../utilties/validators'
import Logo from '../../../assets/logo'
import { injectIntl } from 'react-intl'
import queryString from 'query-string'
import makeStyles from '@material-ui/core/styles/makeStyles'
import translations from '../../../utilties/languages/locales'
import locale2 from 'locale2'
import { teamBackgroundIsLoadingSelector, teamBackgroundSelector, teamLogoIsLoadingSelector, teamLogoSelector, registrationStatusSelector, creatorInfoSelector, selfRegistrationLinkIsValidSelector } from '../../../redux/selectors'
import defaultBackground from '../../../assets/images/default-bg.png'
import defaultLogo from '../../../assets/images/logo_benchmarc.svg'
import InviteInformation from '../../../components/InviteInformation'
import RegistrationPagesWrapper from '../../../components/RegistrationPagesWrapper'

const formName = 'emailVerification';
const requiredValidator = required
const emailValidator = email
const selector = formValueSelector(formName)

const useStyles = makeStyles((theme) => ({
	gridStyle: {
	  padding: '4rem',
	  width: '100%',
	  margin: '0',
	  boxSizing: 'border-box',
	  display: 'flex',
	  flexDirection: 'column',
	  alignItems: 'center',
	  [theme.breakpoints.down('sm')]: {
		padding: '3rem 2rem',
	  }
	},
	buttonsContainer: {
		width: '100%',
		paddingTop: '20px',
		[theme.breakpoints.down('xs')]: {
			flexDirection: 'column-reverse',
		}		
	}
}))

const EmailVerification = ({
	handleSubmit,
	intl,
	location,
	formChangeEmail,
	formChangeVerificationCode,
	formChangeLanguage,
	selfRegister,
	sendVerificationCode,
	confirmCode,
	email,
	language,
	verificationCode,
	teamBackground,
	loadTeamBackground,
	loadTeamBackgroundByEncryptedLink,
	teamBackgroundIsLoading,
	teamLogo,
	teamLogoIsLoading,
	loadTeamLogo,
	loadTeamLogoByEncryptedLink,
    pristine,
    invalid,
	registrationStatus,
	resetRegistrationStatus,
	getRegistrationStatus,
	getCreatorInfo,
	getCreatorInfoByData,
	creatorInfo,
	checkIfSelfRegistrationLinkHasExpired,
	selfRegistrationLinkIsValid
}) => {
	const classes = useStyles()
	const theme = useTheme()

	const [ isRegistrationStarted, setIsRegistrationStarted ] = useState(false)
	const [ isSelfRegistration, setIsSelfRegistration ] = useState(false)
	const [ canSend, setCanSend ] = useState(false)
	const [ showLoader, setShowLoader ] = useState(false)

	const isMobile = useMediaQuery(theme.breakpoints.down('sm'), {
		defaultMatches: true
	});
    const [showCreatorInfoPanel, setShowCreatorInfoPanel] = useState(false)

	
	useEffect(() => {
		resetRegistrationStatus()

		const values = queryString.parse(location.search)

		if (values.email) {
			formChangeEmail(values.email)
			getRegistrationStatus(values.email)
		}

		const data = values.data
		setIsSelfRegistration(!!data)
		if (!!data) {
			setShowLoader(true)
			checkIfSelfRegistrationLinkHasExpired(data)
			loadTeamBackgroundByEncryptedLink(data)
			loadTeamLogoByEncryptedLink(data)
			setShowCreatorInfoPanel(true)
			getCreatorInfoByData(data)
		}

		let locale = 'en';
        
		if (locale2) {
			locale = locale2.substring(0, 5)
			if (locale !== 'en-GB') {
				locale = locale2.substring(0, 2)
			}
		}

        if (!translations[locale]) {
            locale = 'en'
        }

		formChangeLanguage(values.language ? values.language : locale);
	}, [])

	useEffect(() => {
		const values = queryString.parse(location.search)
		const data = values.data

		if (email) {
			if (!data) {
				setShowCreatorInfoPanel(true)
				loadTeamBackground(email)
				loadTeamLogo(email)
			}
			setCanSend(false)

			var trimmedEmail = email.trim()
			if (trimmedEmail != email) {
				formChangeEmail(trimmedEmail)
			}
		}
	}, [email])

	useEffect(() => {
		if (verificationCode?.length > 6) {
			formChangeVerificationCode(verificationCode.substring(0, 6))
		}
	}, [verificationCode])

	useEffect(() => {
		if (!!email && !!language && registrationStatus === 1) {
			onSendVerificationCode()
		}
	}, [email, language, registrationStatus])

	useEffect(
		() => {
			setCanSend(registrationStatus == 0)
		},
		[registrationStatus]
	)

	useEffect(
		() => {
			setShowLoader(!selfRegistrationLinkIsValid)
		},
		[selfRegistrationLinkIsValid]
	)

	const onSendVerificationCode = () => {
		if (!isRegistrationStarted) {
			const data = queryString.parse(location.search).data

			if (!!data && registrationStatus == 0) {
				selfRegister(email, data, language)
			}
			else {
				sendVerificationCode(email, language)
			}

			setIsRegistrationStarted(true)
		}
	}

	const onSubmitForm = (values) => {
		if (registrationStatus == 2) {
			confirmCode(email, values.verificationCode)
		}
	}

	const checkEmail = () => {
		if (
			!requiredValidator(email) &&
			!emailValidator(email)
		) {
			getRegistrationStatus(email)
			setIsRegistrationStarted(false)
		}
	}

	const onKeyPress = (e) => {
		if (e?.key === 'Enter')
		{
			checkEmail()
		}
	}

	const inviterText = () => {
		return creatorInfo
			? creatorInfo.teamName || `${creatorInfo.firstName} ${creatorInfo.lastName}${creatorInfo.credentials ? ', ' + creatorInfo.credentials : ''}`
			: ''
	}

	const protocolName = () => {
		return creatorInfo
			? creatorInfo.protocolName
			: ''
	}

	return (
		showLoader 
		? <div style={{height: '100vh', backgroundColor: 'white'}}><CircularProgress style={{position: 'absolute', top: '50%', left: '50%'}} /></div>
		: <Fragment>
			<LoginPagesWrapper
				logoUrl={teamLogo || !teamLogoIsLoading && defaultLogo}
				backgroundUrl={teamBackground || !teamBackgroundIsLoading && defaultBackground}
				canChangeLanguage={false}
			>
				<RegistrationPagesWrapper
					showCreatorInfoPanel={true}
				>
					<form onSubmit={handleSubmit(onSubmitForm)}
						data-testid='form-register'
						style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', margin: '0', width: '100%' }}>
						<input id="language" name="language" type="hidden" />
						<Paper className={classes.gridStyle} elevation={2}>
							<Grid item style={{ paddingBottom: '20px', textAlign: 'center' }}>
								<Logo />
							</Grid>
							{
								!!creatorInfo
								&& <Grid item xs={12} style={{ paddingBottom: '20px', textAlign: 'center' }}>
									<Typography variant='h4' style={{ fontWeight: '500' }}>{intl.formatMessage({ id: 'app.register.title' }).replace('%%TeamName%%', inviterText()).replace('%%Protocol%%', protocolName())}</Typography>
								</Grid>
							}
							<Grid item xs={12} style={{ paddingBottom: '50px', textAlign: 'center' }}>
								<Typography style={{ fontSize: '14px', fontWeight: '700' }}>
									{intl.formatMessage({ id: 'app.auth.beginRegisteringText' })}
								</Typography>
							</Grid>
							<Grid item xs={12} sm={10} style={{ width: '100%' }}>
								<FormTextField
									data-testid='form-register-input-email'
									label={intl.formatMessage({ id: 'app.email' })}
									fullWidth
									disabled={!isSelfRegistration || registrationStatus != null}
									type='text'
									name='email'
									validators={[requiredValidator, emailValidator]}
									variant='filled'
									onKeyPress={onKeyPress}
								/>
							</Grid>
							{
								registrationStatus == 0
								&& <Grid item xs={12} sm={10} style={{ width: '100%' }}>
									<Typography variant='caption'>
										{intl.formatMessage({ id: 'app.accessCode.emailIsNotRegistered' })}
									</Typography>
								</Grid>
							}
							<Grid
								item
								container
								xs={12}
								sm={10}
								justifyContent="center"
								style={{
									width: '100%',
									paddingTop: '20px'
								}}
							>
								<Grid item>
									<Button
										data-testid="form-backlink-button"
										variant='text'
										color='primary'
										size='small'
										href='/auth/login'
									>
										{intl.formatMessage({ id: 'app.registration.backLinkText' })}                                    
									</Button>
								</Grid>
							</Grid>
							{
								isSelfRegistration
								&& registrationStatus == null
								&& <Grid
									item
									container
									xs={12}
									sm={10}
									justifyContent="center"
									style={{
										width: '100%',
										paddingTop: '20px'
									}}
								>
									<Grid item>
										<Button
											data-testid="form-send-code-button"
											variant='contained'
											color='primary'
											size='small'
											disabled={!email?.length}
											onClick={checkEmail}
											style={{
												minWidth: '150px'
											}}
										>
											{intl.formatMessage({ id: 'app.accessCode.checkEmail' })}                                    
										</Button>
									</Grid>
								</Grid>
							}
							{
								registrationStatus != null
								&& <Grid
									className={classes.buttonsContainer}
									item
									container
									xs={12}
									sm={10}
									justifyContent="center"
								>
									{
										isSelfRegistration
										&& <Grid item xs={12} sm={6} style={{textAlign: 'center'}}>
											<Button
												data-testid="form-reset-registration-status-button"
												variant='outlined'
												color='primary'
												size='small'
												disabled={!email?.length || !canSend}
												onClick={resetRegistrationStatus}
											>
												{intl.formatMessage({ id: 'app.accessCode.back' })}                                    
											</Button>
										</Grid>
									}
									{
										isSelfRegistration
										&& registrationStatus == 0
										&& <Grid item xs={12} sm={6} style={{textAlign: 'center'}}>
											<Button
												data-testid="form-reset-registration-status-button"
												startIcon={
													isRegistrationStarted ?
														<Fragment sx={{ color: 'grey.500' }}>
															<CircularProgress size={17} color="inherit" />
														</Fragment>
														: undefined
												}
												variant='contained'
												color='primary'
												size='small'
												disabled={isRegistrationStarted || !email?.length || !canSend}
												onClick={onSendVerificationCode}
											>
												{isRegistrationStarted ? intl.formatMessage({ id: 'app.accessCode.sending' }) : intl.formatMessage({ id: 'app.accessCode.send' })}                                    
											</Button>
										</Grid>
									}
									{
										registrationStatus == 2
										&& <Grid item xs={6} sm={4} style={{ textAlign: 'right' }}>
											<Button
												data-testid="form-verify-button"
												type='submit'
												variant='contained'
												color='primary'
												size='small'
												disabled={pristine || invalid}
											>
												{intl.formatMessage({ id: 'app.general.verify' })}                                    
											</Button>
										</Grid>
									}
								</Grid>
							}
						</Paper>
					</form>
				</RegistrationPagesWrapper>
			</LoginPagesWrapper>
		</Fragment>
	)
}

const mapStateToProps = (state) => ({
	failed: state.auth.failedLogin,
	email: selector(state, 'email'),
	language: selector(state, 'language'),
	verificationCode: selector(state, 'verificationCode'),
	teamBackground: teamBackgroundSelector(state),
	teamBackgroundIsLoading: teamBackgroundIsLoadingSelector(state),
    teamLogo: teamLogoSelector(state),
	teamLogoIsLoading: teamLogoIsLoadingSelector(state),
	registrationStatus: registrationStatusSelector(state),
	creatorInfo: creatorInfoSelector(state),
	selfRegistrationLinkIsValid: selfRegistrationLinkIsValidSelector(state)
})

const mapDispatchToProps = (dispatch) => ({
	formChangeEmail: (email) => dispatch(change(formName, 'email', email)),
	formChangeVerificationCode: (verificationCode) => dispatch(change(formName, 'verificationCode', verificationCode)),
	formChangeLanguage: (language) => dispatch(change(formName, 'language', language)),
	selfRegister: (email, search, language) => dispatch(selfRegisterUser(email, search, language)),
	sendVerificationCode: (email, language) => dispatch(sendVerificationCode(email, language)),
	confirmCode: (email, verificationCode) => dispatch(confirmCode(email, verificationCode)),
	loadTeamBackground: (email) => dispatch(getTeamBackgroundByEmail(email)),
	loadTeamBackgroundByEncryptedLink: (data) => dispatch(getTeamBackgroundByEncryptedLink(data)),
	loadTeamLogo: (email) => dispatch(getTeamLogoByEmail(email)),
	loadTeamLogoByEncryptedLink: (data) => dispatch(getTeamLogoByEncryptedLink(data)),
	resetRegistrationStatus: () => {
		dispatch(resetRegistrationStatus())
		dispatch(change(formName, 'email', ''))
	},
	getRegistrationStatus: (email) => dispatch(getRegistrationStatus(email)),
	getCreatorInfo: (email) => dispatch(getCreatorInfoByEmail(email)),
	getCreatorInfoByData: (data) => dispatch(getCreatorInfoByEncryptedLink(data)),
	checkIfSelfRegistrationLinkHasExpired: (data) => dispatch(checkIfSelfRegistrationLinkHasExpired(data))
})

const enhance = compose(
	connect(mapStateToProps, mapDispatchToProps),
	injectIntl,
	reduxForm({
		form: formName
	}),
	withRouter
)

export default enhance(EmailVerification)
